import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import useRadio from "./useRadio";
import useRadioGroup from "./useRadioGroup";
import styles from "./RadioButtons.module.scss";
import { SCORING } from "../hooks/useQuestions";
import Text from "../Text/Text";

function RadioButtons(props) {
  const { currentQuestion, handleSelection } = props;
  const options = SCORING;
  const { getRadioProps } = useRadioGroup({
    name: "action",
    onChange: (e) =>
      handleSelection({
        answer: e,
        questionId: currentQuestion.id,
      }),
    value: currentQuestion.answer,
  });
  return (
    <Buttons>
      {options.map((answer) => {
        const radio = getRadioProps(answer);
        return (
          <RadioButton
            key={answer.value}
            {...radio}
            currentQuestion={currentQuestion}
          >
            {answer.value}
          </RadioButton>
        );
      })}
    </Buttons>
  );
}

RadioButtons.propTypes = {
  currentQuestion: PropTypes.shape({
    answer: PropTypes.string,
    dimension: PropTypes.string,
    id: PropTypes.number,
    question: PropTypes.string,
    subDimension: PropTypes.string,
  }),
  handleSelection: PropTypes.func,
};

function Buttons({ children }) {
  return <div className={styles.buttons}>{children}</div>;
}

Buttons.propTypes = {
  children: PropTypes.node,
};

function RadioButton(props) {
  const { currentQuestion, ...rest } = props;
  const { getCheckboxProps, getInputProps } = useRadio(rest);
  const { children } = props;
  const input = getInputProps();
  const checkbox = getCheckboxProps();

  const inputRef = useRef();

  /** Remove the focus outline when the question changes */
  useEffect(() => {
    inputRef.current.blur();
  }, [currentQuestion]);
  return (
    <label>
      <input ref={inputRef} {...input} className={styles.radio} />
      <div {...checkbox} className={styles.radio_button}>
        <span className={styles.fake_radio}>
          {input.checked && <span className={styles.fake_radio_inner} />}
        </span>
        <Text>{children}</Text>
      </div>
    </label>
  );
}

RadioButtons.propTypes = {
  children: PropTypes.node,
};

export default RadioButtons;
